import { FC, lazy, Suspense } from 'react';
import { PdpSharedDetail, PdpSharedDetailProps } from './PdpSharedDetail';

type Props = PdpSharedDetailProps & {
    isClient: boolean;
};

export const PdpSharedDetailLabReport: FC<Props> = ({
    currency,
    delimiter,
    detailValues,
    isClient,
    selectedSkuId,
}) => {
    const LabReportTip = lazy(
        () =>
            import(
                /* webpackChunkName: "PdpSharedDetailLabReportTip" */ './PdpSharedDetailLabReportTipLazy'
            )
    );

    return (
        <>
            <PdpSharedDetail
                detailValues={detailValues}
                currency={currency}
                delimiter={delimiter}
                selectedSkuId={selectedSkuId}
            />
            {isClient && (
                <Suspense fallback="">
                    <LabReportTip />
                </Suspense>
            )}
        </>
    );
};
